var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalBarChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Widget/VertBar/JDPower/Simplified") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Widget/VertBar/JDPower/Simplified",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chart",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 4.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105,15.7574264 C105,14.1019935 106.350498,12.76 107.99649,12.76 L130.00351,12.76 C131.658426,12.76 133,14.1058045 133,15.7574264 L133,111.762574 C133,113.418006 131.649502,114.76 130.00351,114.76 L107.99649,114.76 C106.341574,114.76 105,113.414196 105,111.762574 L105,15.7574264 Z",
    id: "Bar",
    fill: "#2E5799",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,115 L0,115 L0,0 Z M0,114 L210,114 L210,115 L0,115 L0,114 Z",
    id: "Graph-Frame",
    fill: "#979797",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,29.9947369 C6,28.3407894 7.3504982,27 8.99649048,27 L31.0035095,27 C32.6584255,27 34,28.3491022 34,29.9947369 L34,111.005263 C34,112.659211 32.6495018,114 31.0035095,114 L8.99649048,114 C7.34157448,114 6,112.650898 6,111.005263 L6,29.9947369 Z",
    id: "Bar",
    fill: "#2E5799",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,24.0020205 C39,22.3440504 40.3504982,21 41.9964905,21 L64.0035095,21 C65.6584255,21 67,22.3505265 67,24.0020205 L67,110.99798 C67,112.65595 65.6495018,114 64.0035095,114 L41.9964905,114 C40.3415745,114 39,112.649473 39,110.99798 L39,24.0020205 Z",
    id: "Bar",
    fill: "#2E5799",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,33.2843228 C72,31.6250811 73.3504982,30.28 74.9964905,30.28 L97.0035095,30.28 C98.6584255,30.28 100,31.6289507 100,33.2843228 L100,110.995677 C100,112.654919 98.6495018,114 97.0035095,114 L74.9964905,114 C73.3415745,114 72,112.651049 72,110.995677 L72,33.2843228 Z",
    id: "Bar",
    fill: "#2E5799",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,35.0997748 C138,33.4430449 139.350498,32.1 140.99649,32.1 L163.00351,32.1 C164.658426,32.1 166,33.4363612 166,35.0997748 L166,111.000225 C166,112.656955 164.649502,114 163.00351,114 L140.99649,114 C139.341574,114 138,112.663639 138,111.000225 L138,35.0997748 Z",
    id: "Bar",
    fill: "#2E5799",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,14.9974264 C171,13.3419935 172.350498,12 173.99649,12 L196.00351,12 C197.658426,12 199,13.3458045 199,14.9974264 L199,111.002574 C199,112.658006 197.649502,114 196.00351,114 L173.99649,114 C172.341574,114 171,112.654196 171,111.002574 L171,14.9974264 Z",
    id: "Bar",
    fill: "#2E5799",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalBarChart);
export default __webpack_public_path__ + "static/media/vertical-bar-chart.85b16e7c16fbc7869793924935121ad3.svg";
export { ForwardRef as ReactComponent };